import { NavLink, NavLinkProps } from '@mantine/core';

import classes from './NavLink.module.css';

const NavLinkDefaults = NavLink.extend({
  classNames: {
    root: classes.root,
    label: classes.label,
  },
});

export { NavLink, NavLinkDefaults };
export type { NavLinkProps };
